import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CTooltipButtonComponent } from './c-tooltip-button.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [CTooltipButtonComponent],
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [CTooltipButtonComponent]
})
export class CTooltipButtonModule { }
